


















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import SimplePagination from "@/components/simple_pagination.vue";
import Copy from "@/components/copy.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/model-left-nav.vue";
import ConfirmDialog from "@/components/dialogs/confirmDialog.vue";
import modelClasses from "../my-model/modelClasses";
import ReleaseDialog from "../../components/model-release.vue";
@Component({
  components: {
    SimplePagination,
    Copy,
    MainHeader,
    LeftNav,
    ConfirmDialog,
    ReleaseDialog
  }
})
export default class MyModel extends Vue {
  // 搜索
  private filter: any = {
    type: "",
    search: ""
  };
  // 数据
  private models: any[] = [];
  private modelClasses: any = modelClasses;
  // 翻页
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  // 确认弹窗
  private cModel: any = {};
  private confirmState: "delete" = "delete";
  private confirmVisible: boolean = false;
  private confirmTitle: any = "温馨提示";
  private confirmHelp: any = "您确定删除该模型么？删除后将无法恢复";
  // 申请发布弹窗
  private ifShowRelease: boolean = false;
  /**
   * @description 获取模型
   */
  private fetchModels() {
    const params: any = {
      params: {
        current_page: this.currentPage,
        page_count: this.pageSize,
        模型分类: this.filter.type,
        search: this.filter.search
      }
    };
    axios.get("api/model/list", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.models = data.data.models;
        this.totalPage = data.data.total_page;
        this.totalCount = data.data.total_count;
      });
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.currentPage = 1;
    this.fetchModels();
  }
  /**
   * @description 绘制柱状图
   */
  private CalBar(model) {
    if (!model["模型效果"]) {
      return null;
    }
    const data: any = model["模型效果"]["data"];
    const name: any = model["模型效果"]["name"];
    return {
      color: ["#5B8FF9"],
      grid: {
        height: "90%",
        bottom: "15%"
      },
      tooltip: {},
      yAxis: {
        type: "value"
      },
      xAxis: {
        data: name,
        type: "category"
      },
      series: [
        {
          type: "bar",
          data
        }
      ]
    };
  }
  /**
   * @description 前一页
   */
  private prev() {
    if (this.currentPage <= 1) {
      return;
    }
    this.currentPage--;
    this.fetchModels();
  }
  /**
   * @description 下一页
   */
  private next() {
    if (this.currentPage >= this.totalPage) {
      return;
    }
    this.fetchModels();
  }
  /**
   * @description 打开删除弹窗确认
   */
  private openDeleteDialog(model) {
    this.confirmState = "delete";
    this.confirmTitle = "温馨提示";
    this.confirmHelp = "您确定删除该模型么？删除后将无法恢复";
    this.confirmVisible = true;
    this.cModel = model;
  }
  /**
   * @description 处理弹窗取消
   */
  private handleCancel() {
    this.confirmVisible = false;
  }
  /**
   * @description 处理弹窗确定
   */
  private handleConfirm() {
    switch (this.confirmState) {
      case "delete":
        this.deleteModel();
        break;
    }
  }
  /**
   * @description 删除一个模型
   */
  private deleteModel() {
    const params: any = {
      data: {
        model_id: this.cModel.model_id
      }
    };
    axios.delete("api/model", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("删除成功");
        this.confirmVisible = false;
        this.fetchModels();
      });
    });
  }
  /**
   * @description 跳转模型训练
   */
  private startTrain(model) {
    const { href } = this.$router.resolve({
      path: "/main/model/model-train/" + model.model_id
    });
    window.open(href, "_blank");
  }
  /**
   * @description 停止一个训练
   */
  private stopTrain(model) {
    const params: any = {
      model_id: model.model_id,
      version_id: model.version_id,
      action: "停止"
    };
    axios.post("api/model/train/do", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("停止成功");
        this.fetchModels();
      });
    });
  }
  /**
   * @description 重新开始模型训练
   */
  private restartTrain(model) {
    const params: any = {
      model_id: model.model_id,
      version_id: model.version_id,
      action: "开始"
    };
    axios.post("api/model/train/do", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("训练开始");
        this.fetchModels();
      });
    });
  }
  /**
   * @description 打开申请发布弹窗
   */
  private openReleaseDialog(model) {
    this.cModel = model;
    this.ifShowRelease = true;
  }
  /**
   * @description 跳转模型试用
   */
  private tryTrain(model) {
    const { href } = this.$router.resolve({
      path: "/main/model/model-trial/" + model.model_id
    });
    window.open(href, "_blank");
  }
  /**
   * @description 申请发布
   */
  private releaseModel() {
    console.log(this.cModel);
  }
  /**
   * @description 跳转模型报告
   */
  private goToReport(model) {
    this.$router.push("/main/model/model-report/" + model.model_id);
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.fetchModels();
  }
}
